<template>
    <v-dialog v-model="overlay">
      <v-card class="d-flex">
        <v-card-actions class="ml-auto">
          <v-btn color="green darken-1 ml-auto" text @click="overlay = false">Close</v-btn>
        </v-card-actions>
      </v-card>
	    <v-card class="d-flex justify-center">
		    <v-img
				    v-if="isImg"
				    :src="link"
				    max-width="700"
		    ></v-img>
		    <embed v-else class="ml-auto mr-auto mt-6" :src="link" :width="width" :height="height" />
      </v-card>
    </v-dialog>
</template>
<script>
export default {
	props: {
		linkDoc: String,
		fileName: String,
	},
	data() {
		return {
			overlay: true,
			isImg: false,
		};
	},
	computed: {
		link() {
			return this.linkDoc;
		},
		height() {
			return self.innerHeight - 200;
		},
		width() {
			return self.innerWidth - 100;
		}
	},
	mounted() {
		if (this.fileName) {
			const f = this.fileName.split('.').pop();
			if (f === 'png' || f === 'jpg' || f === 'gif' || f === 'jpeg') {
				this.isImg = true;
			} else {
				this.isImg = false;
			}
		}
	},
	watch: {
		overlay(val) {
			if (!val) {
				this.$emit('clear-link');
			}
		}
	}
};
</script>
